import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';
import { ADMIN_CENTER } from '@confluence/named-routes/entry-points/routes.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { LazyAssignRolesPage } from '@confluence/space-roles/entry-points/AssignRolesPage.ts';

const PERMISSIONS_COMBINATIONS_ANALYTICS_SOURCE = 'adminPermissionsCombinations';

export const PermissionsCombinationsRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => {
	const { edition } = useSessionData();

	// Free sites can't manage space permissions, so the Transition to roles page is
	// not available even when the tenant is mid-transition (a previously paid Free site).
	if (edition === ConfluenceEdition.FREE) {
		return <Redirection name={ADMIN_CENTER.name} />;
	}

	return <LazyAssignRolesPage />;
};
PermissionsCombinationsRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: PERMISSIONS_COMBINATIONS_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
